var _rect, _path, _path2, _path3, _path4, _path5, _circle, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    rx: 56,
    fill: "#EEEEF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.1895 77.4697C32.1895 75.0756 34.1303 73.1348 36.5244 73.1348H69.656V76.8505C69.656 79.5866 67.4379 81.8047 64.7017 81.8047H36.5244C34.1303 81.8047 32.1895 79.8639 32.1895 77.4697Z",
    fill: "#91CED2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7793 68.8018C28.7793 66.4076 30.7201 64.4668 33.1143 64.4668H69.6519V73.1367H33.1143C30.7201 73.1367 28.7793 71.1959 28.7793 68.8018Z",
    fill: "#91CED2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6113 60.1318C26.6113 57.7377 28.5522 55.7969 30.9463 55.7969H69.6514V64.4668H30.9463C28.5522 64.4668 26.6113 62.526 26.6113 60.1318Z",
    fill: "#91CED2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6113 51.4619C26.6113 49.0678 28.5522 47.127 30.9463 47.127H68.0739C68.9452 47.127 69.6514 47.8332 69.6514 48.7044V55.7969H30.9463C28.5522 55.7969 26.6113 53.8561 26.6113 51.4619Z",
    fill: "#91CED2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5877 24.832C63.3239 24.832 65.542 27.0501 65.542 29.7863L65.542 47.7455C65.542 50.4816 63.3239 52.6997 60.5877 52.6997L52.8467 52.6997L52.8467 29.7863C52.8467 27.0501 55.0648 24.832 57.801 24.832L60.5877 24.832Z",
    fill: "#91CED2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.1382,
    cy: 49.5288,
    r: 8.51512,
    fill: "#91CED2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6803 52.082C72.3122 52.082 71.2031 53.1911 71.2031 54.5592V79.3304C71.2031 80.6985 72.3122 81.8076 73.6803 81.8076H82.9695C84.3376 81.8076 85.4466 80.6985 85.4466 79.3304V54.5592C85.4466 53.1911 84.3376 52.082 82.9695 52.082H73.6803ZM78.4829 78.0841C79.5719 78.0841 80.4547 77.2012 80.4547 76.1122C80.4547 75.0232 79.5719 74.1404 78.4829 74.1404C77.3938 74.1404 76.511 75.0232 76.511 76.1122C76.511 77.2012 77.3938 78.0841 78.4829 78.0841Z",
    fill: "#2E3E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.f6cd8b2fd1c0c8062e81a5efa069165c.svg";
export { ForwardRef as ReactComponent };